import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import { PartnersService } from '../../../services/partners/partners.service';
import {FieldType, MemberAddeditComponent, MemberAddeditDialogModel} from '../../brokeragency/member-addedit/member-addedit.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Component({
  selector: 'app-brands-page',
  templateUrl: './brands-page.component.html',
  styleUrls: ['./brands-page.component.scss']
})
export class BrandsPageComponent implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;

  protected allColumnNames = ['name', 'colors', 'url', 'logo', 'actionmenu'];
  protected items = new MatTableDataSource<any>();

  private addEditFields = [
    {name: 'name', label: 'Brand name', fieldType: FieldType.F_STRING, required: true},
    {name: 'ourlyPrimaryColor', label: 'ourlyPrimaryColor', fieldType: FieldType.F_COLOR, required: false},
    {name: 'ourlySecondaryColor', label: 'ourlySecondaryColor', fieldType: FieldType.F_COLOR, required: false},
    {name: 'wallitTertiaryColor', label: 'wallitTertiaryColor', fieldType: FieldType.F_COLOR, required: false},
    {name: 'wallitGradientNEColor', label: 'wallitGradientNEColor', fieldType: FieldType.F_COLOR, required: false},
    {name: 'wallitGradientSWColor', label: 'wallitGradientNEColor', fieldType: FieldType.F_COLOR, required: false},
    {name: 'lightLogoUrl', label: 'lightLogoUrl (logo on light)', fieldType: FieldType.F_IMAGE, required: false},
    {name: 'lightLogoUrlImageData', invisible: () => true, label: 'lightLogoUrlImageData (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'lightLogoUrlImageDataSrc', invisible: () => true, label: 'lightLogoUrlImageData (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'logoUrl', label: 'logoUrl (logo on dark)', fieldType: FieldType.F_IMAGE, required: false},
    {name: 'logoUrlImageData', invisible: () => true, label: 'logoUrlImageData (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'logoUrlImageDataSrc', invisible: () => true, label: 'logoUrlImageDataSrc (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'horizontalLogoOnWhite', label: 'horizontalLogoOnWhite (horizontal logo on white)', fieldType: FieldType.F_IMAGE, required: false},
    {name: 'horizontalLogoOnWhiteImageData', invisible: () => true, label: 'horizontalLogoOnWhiteImageData (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'horizontalLogoOnWhiteImageDataSrc', invisible: () => true, label: 'horizontalLogoOnWhiteImageDataSrc (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'horizontalLogoUrl', label: 'horizontalLogoUrl (horizontal logo on dark)', fieldType: FieldType.F_IMAGE, required: false},
    {name: 'horizontalLogoUrlImageData', invisible: () => true, label: 'horizontalLogoUrlImageData (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'horizontalLogoUrlImageDataSrc', invisible: () => true, label: 'horizontalLogoUrlImageDataSrc (invisible)', fieldType: FieldType.F_HIDDEN_DATA, required: false},
    {name: 'signupDisabled', label: 'Signup disabled', fieldType: FieldType.F_TOGGLE, required: false},
    {name: 'configjson', label: 'Config JSON', fieldType: FieldType.F_JSON, required: false, validateJson: this.validateJson},
  ];

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private partnersService: PartnersService,
  ) {}

  ngOnInit(): void {
    this.reloadItems();
  }

  addItem(): void {
    console.log('Clicked add new branding button!');
  }

  clickMenuItem(item: any): void {
    console.log(item);
  }

  editItem(item: any): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(item, this.addEditFields, 'Brand Config')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        const logoPromises: Promise<void>[] = [];
        // Update values in item before PUTing to API
        for (const key of Object.keys(dialogResult)) {
          if (key.endsWith('ImageData')) {
            const baseKey = key.substring(0, key.indexOf('ImageData'));
            const logoType = this.logoTypeForBaseKey(baseKey);

            if (dialogResult[key] && logoType) {
              logoPromises.push(this.partnersService.changePartnerLogo(item.partnerId, dialogResult[key], logoType));
              item[baseKey] = '';
            }
          }  else if (key.endsWith('ImageDataSrc')) {
            // Do nothing with the image src data, this is used to display on the edit component
          } else {
            item[key] = dialogResult[key];
          }
        }
        this.partnersService.updatePartner(item).then((updatedPartner) => {
          // TODO: maybe add loader for all image requests?
          Promise.all(logoPromises).then((values) => {
            this.reloadItems(item.partnerId);
            this.snackBar.open('Brand config updated', 'Close', {
              duration: 3000
            });
          });
        });
      }
    });
  }

  // TODO: update with full json validation for brands config
  validateJson(control: any): any {
    if (control.value) {
      for (const band of control.value?.bands) {
        if (!band?.title || !band?.type) {
          return { badBand: band };
        }
      }
    }
    return null;
  }

  private logoTypeForBaseKey(baseKey: string): 'avatar' | 'lightlogo' | 'horizontallogo' | 'horizontallightlogo' | null {
    switch (baseKey) {
      case 'logoUrl':
        return 'avatar';
      case 'lightLogoUrl':
        return 'lightlogo';
      case 'horizontalLogoOnWhite':
        return 'horizontallightlogo';
      case 'horizontalLogoUrl':
        return 'horizontallogo';
      default:
        return null;
    }
  }

  private reloadItems(reloadAvatarImageForPartnerId?: string): void {
    this.partnersService.getAllPartners().then(partners => {
      if (partners && partners.length > 0 && reloadAvatarImageForPartnerId) {
        const timestamp = new Date().getTime();
        const partnerToReloadAvatarImageFor = partners.find(partner => partner.partnerId === reloadAvatarImageForPartnerId);
        if (partnerToReloadAvatarImageFor) {
          partnerToReloadAvatarImageFor.logoUrl = partnerToReloadAvatarImageFor?.logoUrl
            ? partnerToReloadAvatarImageFor.logoUrl += `?reloadTimestamp=${timestamp}`
            : '';
        }
      }
      // Default to alphabetical sort
      this.items.data = partners.sort((partner1, partner2) => partner1.name > partner2.name ? 1 : -1);
      this.items.sort = this.sort;
    });
  }
}
